module.exports = __webpack_public_path__ + "static/media/Page1-HotApp.df5b849e.png";